import { config } from './api';
import { ICurrency } from './common';
import { ICompany } from './Companies';

// =====================================================================
// These interfaces align with the PHP structs (without the `I` prefix).
// =====================================================================

export interface IMaDirectPlanTier {
  basePrice: number;
  leadLimit: number;
  firstEmailLimit: number;
  firstEmailOveragePrice: number;
  secondEmailLimit: number;
  secondEmailOveragePrice: number;
}

export interface IBasicPlanResponseCents {
  externalCRMPrice: number;
  leadOveragePricePerThousand: number;

  pageImpressionsMultiplier: number;
  pageImpressionsOveragePrice: number;
  pageImpressionsLimit: number;

  mailboxSyncPrice: number;

  includedSalesDialerSeats: number;
  salesDialerPrice: number;
}

export interface IMaDirectPlan {
  currencyID: number;
  tiers: IMaDirectPlanTier[];
  commonProperties: IBasicPlanResponseCents;
}

export interface IPlanResponse {
  company: ICompany;
  currencies: ICurrency[];
  plan: IMaDirectPlan;
  includedMailSyncSeats: number|null;
}

export const getPlan = async (authToken: string, companyID: number): Promise<IPlanResponse> => {
  const res = await fetch(`${config.url}/company/${companyID}/plan`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + authToken,
      'Content-Type': 'application/json',
    },
  });

  if (res.ok) {
    const body = await res.json();
    return body.result;
  } else {
    throw new Error(`Request failed: ${res.status} ${res.statusText}`);
  }
}
